"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _react2 = require("@emotion/react");

var _styledSystem = require("styled-system");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _system = _interopRequireWildcard(require("../../utils/system"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _variants;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var sizes = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
var propTypes = {
  /**
   * An accessible label for the spinner
   */
  label: _propTypes.string,

  /**
   * The color of the spinner.
   */
  color: _propTypes.string,

  /**
   * The color of the empty border in spinner.
   */
  emptyColor: _propTypes.string,

  /**
   * There are two ways you can increase the height of the progress bar, using
   * this prop or `height` supplied by styled-system.
   */
  size: (0, _propTypes.oneOf)(Object.values(sizes)),

  /**
   * Override or extend the styles applied to the components.
   */
  classes: (0, _propTypes.shape)({
    root: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func]),
    label: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func])
  })
};
var defaultProps = {
  size: sizes.md,
  label: 'Loading...',
  color: 'primary.main',
  emptyColor: 'transparent',
  classes: {
    root: null,
    label: null
  }
};
var spinAnimation = (0, _react2.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var Spinner = (0, _system["default"])('div')({
  label: 'Spinner'
}, function (_ref) {
  var emptyColor = _ref.emptyColor,
      color = _ref.cColor;
  return (0, _css["default"])({
    color: color,
    borderWidth: 2,
    borderStyle: 'solid',
    borderRadius: 'full',
    boxSizing: 'border-box',
    display: 'inline-block',
    borderColor: 'currentColor',
    verticalAlign: 'text-bottom',
    borderRightColor: emptyColor,
    borderBottomColor: emptyColor,
    animation: "".concat(spinAnimation, " 0.45s linear infinite")
  });
}, (0, _styledSystem.variant)({
  scale: 'spinner',
  prop: 'cSize',
  variants: (_variants = {}, _defineProperty(_variants, sizes.sm, {
    size: 6
  }), _defineProperty(_variants, sizes.md, {
    size: 12
  }), _defineProperty(_variants, sizes.lg, {
    size: 16
  }), _variants)
}), (0, _system.classesStyles)('root'));
var Label = (0, _base["default"])("div", process.env.NODE_ENV === "production" ? {
  target: "ec6yj9t0"
} : {
  target: "ec6yj9t0",
  label: "Label"
})((0, _css["default"])({
  size: 0,
  margin: 0,
  padding: 0,
  overflow: 'hidden',
  position: 'absolute'
}), (0, _system.classesStyles)('label'));
var Component = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var size = _ref2.size,
      label = _ref2.label,
      color = _ref2.color,
      props = _objectWithoutProperties(_ref2, ["size", "label", "color"]);

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Spinner, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    cSize: size,
    cColor: color,
    role: "progressbar",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Label, {
      classes: props.classes,
      children: label
    })
  }));
});
Component.displayName = 'Spinner';
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=Spinner.js.map